import { FC } from 'react'
import { CreateButton, Datagrid, FunctionField, List, SearchInput, TextField } from 'react-admin'
import { CERTIFICATE_ORGANIZATION_WRITE_SCOPE } from '../../config'
import { ListActionsToolbar, RestrictedButton } from '../../components'
import type { OrganizationRecord } from '../../types/apiTypes'

// Linked apps as "zaken: Gemeente X"; falls back to the external id when the name is unknown.
const linkedApps = (record: OrganizationRecord): string =>
  Object.entries(record.apps ?? {})
    .filter(([, externalId]) => !!externalId)
    // `key` comes from Object.entries above, not from user input.
    // eslint-disable-next-line security/detect-object-injection
    .map(([key, externalId]) => `${key}: ${record.appNames?.[key] || externalId}`)
    .join(', ')

const OrganizationsList: FC = () => (
  <List
    filters={[<SearchInput key="q" source="q" alwaysOn />]}
    sort={{ field: 'name', order: 'ASC' }}
    actions={
      <ListActionsToolbar i18n="resources.organization.list">
        <RestrictedButton access={[CERTIFICATE_ORGANIZATION_WRITE_SCOPE]} align="right">
          {(): JSX.Element => <CreateButton variant="contained" />}
        </RestrictedButton>
      </ListActionsToolbar>
    }
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="name" label="resources.organization.fields.name" />
      <TextField source="organizationId" label="resources.organization.fields.organizationId" />
      <FunctionField label="resources.organization.fields.apps" render={linkedApps} />
    </Datagrid>
  </List>
)

export default OrganizationsList
